"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseVersion = exports.parseUuid = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const isNumber_1 = tslib_1.__importDefault(require("lodash/isNumber"));
const isString_1 = tslib_1.__importDefault(require("lodash/isString"));
const toNumber_1 = tslib_1.__importDefault(require("lodash/toNumber"));
const parseUuid = (uuid) => {
    if (!(0, isString_1.default)(uuid)) {
        return null;
    }
    if (!(0, class_validator_1.isUUID)(uuid)) {
        return null;
    }
    return uuid;
};
exports.parseUuid = parseUuid;
const parseVersion = (version) => {
    if (!(0, isNumber_1.default)(version) && !(0, class_validator_1.isNumberString)(version)) {
        return null;
    }
    return (0, toNumber_1.default)(version);
};
exports.parseVersion = parseVersion;
